<template>
  <div class="max-w-4xl mx-auto min-w-0 overflow-x-hidden px-4 py-8">
    <Breadcrumbs :items="[{ label: page?.title || slug }]" />

    <div v-if="loading" class="space-y-4">
      <USkeleton class="h-10 w-64" />
      <USkeleton class="h-64 rounded-xl" />
    </div>

    <template v-else-if="page">
      <h1 class="mb-6 text-2xl font-bold text-highlighted md:text-3xl">{{ page.title }}</h1>
      <CmsContent :content="page.content" />
    </template>

    <div v-else class="text-center py-16">
      <h1 class="text-2xl font-bold text-highlighted mb-4">Pagina nu a fost găsită</h1>
      <UButton label="Înapoi acasă" :to="shopPath('/')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CmsPage } from '~/types'

const shopPath = useShopPath()
const route = useRoute()
const { get } = useApi()

const slug = computed(() => String(route.params.slug || '').toLowerCase())
const page = ref<CmsPage | null>(null)
const loading = ref(true)

onMounted(async () => {
  if (!slug.value) {
    loading.value = false
    return
  }
  try {
    const response = await get<CmsPage>(`/pages/${slug.value}`)
    if (response.success && response.data) {
      page.value = response.data
      useSeo({
        title: response.data.metaTitle || response.data.title,
        description: response.data.metaDescription || response.data.title,
      })
    }
  } finally {
    loading.value = false
  }
})
</script>
